import { Navigate, useParams } from 'react-router-dom';
import { useFolder } from '@modules/items/api/folders.api';
import { isTFolder } from '@modules/items/types/folders.types';
import { StatusLabel } from '@shared/components/StatusLabel';
import { useDocumentTitle } from '@shared/hooks/useDocumentTitle.hook';
import { TERMINOLOGY } from '@shared/i18n/terminology';
import { useProject } from '../api';
import ProjectDetailsContent from '../components/ProjectDetailsContent';
import { useProjectsSettings } from '../hooks/useProjectsSettings.hook';

const ProjectDetails = () => {
  const { projectId } = useParams();
  const { enabled, enabledRootItemTypes } = useProjectsSettings();
  const { data: projectData, error: projectError } = useProject(projectId!, enabled);
  const { data: folderData, error: folderError } = useFolder(projectData?.project.parent, {
    enabled: enabled && !!projectData,
  });
  const folder = folderData && isTFolder(folderData) ? folderData : undefined;
  const data = folder && projectData ? { folder, ...projectData } : undefined;
  useDocumentTitle(projectData?.project.name ?? TERMINOLOGY.project.upper);

  if (!enabled || (folder && !enabledRootItemTypes?.some((type) => type === folder.resolvedPath[0]?.folderType)))
    return <Navigate to="/" replace />;

  return (
    <StatusLabel
      data={data}
      error={projectError ?? folderError}
      loadingMessage={`Loading ${TERMINOLOGY.project.lower}...`}
      errorMessage={`Loading ${TERMINOLOGY.project.lower} failed!`}
      render={(resolved) => <ProjectDetailsContent {...resolved} />}
    />
  );
};

export default ProjectDetails;
